<template>
  <div class="mainbody cart-page">
    <!--<code>   {{ carts }}</code>-->
    <div class="container-fluid">
      <div class="col-md-12">
        <div class="order-items">
          <h3 class="c-title mb10" v-if="language=='EN'"> Verify products in Your Bag</h3>
          <h3 class="c-title mb10" v-else> আপনার ব্যাগের পণ্য যাচাই করুন </h3>
          <div class="table-responsive no-border">
            <table class="table    table-striped checkout-table">
              <thead>
                <tr>
                  <th width="32px"></th>
                  <th colspan="2">Product</th>
                  <th class="text-center">Unit&nbsp;Price</th>
                  <th class="text-center">Quantity</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>

            <tr v-for="(cart , cartindex) in carts">
              <!--<td>{{cart.product_id}}</td>-->
              <td class="text-center" width="32px">
                <div @click="removeCartItem(cart.product_id)">
                  <img style="width: 30px" src="@/assets/images/icons/close-x.png" class="remove">

                </div>
              </td>
              <td width="75px">
                <div>
                  <img v-bind:src="fileUrl+'uploads/products/'+cart.product_image" class="  img-bordered img-thumbnail">
                </div>
              </td>
              <td>
                <div>
                  <span v-if="language=='EN'">{{cart.product_name}}</span>
                  <span v-else>{{cart.product_name_bn}}</span>
                  <br>
                  <small>{{cart.quantity}} {{cart.unit}} </small>
                </div>
              </td>
              <td class="text-center base-color w500" :data-label="language=='EN' ? 'Unit Price' : 'ইউনিট মূল্য'"> {{cart.price.toFixed(2)}} &#8364;</td>
              <td class="text-center">
                <div class="count-quantity">
                  <div class="top">
                    <span @click="cartIncrement(cart.product_id)"><img src="@/assets/images/icons/plus.png"
                        width="13px" /></span>
                  </div>
                  <div class="cart_quantity green-color">{{cart.cart_quantity}}</div>
                  <div class="bottom">
                    <span @click="cartDecrement(cart.product_id)"><img src="@/assets/images/icons/minus.png"
                        width="15px" /></span>
                  </div>
                </div>
              </td>
              <td class="base-color w500" :data-label="language=='EN' ? 'Total' : 'মোট'">{{cart.subtotal.toFixed(2)}} &#8364;</td>

            </tr>
            <tr>
              <td colspan="5" class="text-right">Cart Total</td>
              <td colspan="1" class="base-color w500"> {{sum_cart_total.toFixed(2)}} &#8364;</td>
            </tr>
              </tbody>
            </table>
          </div>

          <router-link v-if="carts.length>0 && language=='EN'" :to="{ path: '/checkout'}"
            class="btn btn-base pull-right mr0">Proceed To Checkout</router-link>
          <router-link v-if="carts.length>0 && language=='BN'" :to="{ path: '/checkout'}"
            class="btn btn-base pull-right mr0">চেকআউট করুন </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const $ = require('jquery');
  window.$ = $;
  $(function () {
    $(window)
      .scroll(function () {
        $('nav')
          .toggleClass('scrolled', $(this)
            .scrollTop() > 50);
      });

  });

  import axios from 'axios';

  export default {
    data() {
      return {
        token: '',
        products: [],
        getcarts: [],
        modalProductData: [],
        recentViews: [],
        categories: [],
        carts: [],
        loadMore: true,
        isOpen: true,
        sum_cart_total: '',
        quantity: 1,
        images: [],
        parseCartData: [],
        changeModalGallery_image: '',
        language:''
      };
    },
    created: function () {
      //localStorage.clear();
      this.language=this.globalLanguage;

    },

    mounted() {
      // this.getImagesInfo()
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
      let vm = this;
      if (localStorage.getItem("token")) {
        let vm = this;
        vm.token = localStorage.getItem("token");
      }

      if (localStorage.getItem("carts")) {
        vm.carts = JSON.parse(localStorage.getItem("carts"));
      } else {
        vm.carts = [];
      }
      this.calculateCartTotal();
    },
    methods: {

      cartHide: function () {
        this.isOpen = !this.isOpen;
      },
      calculateCartTotal() {
        let vm = this;
        for (var i = 0, sum = 0; i < vm.carts.length; sum += vm.carts[i++].subtotal);
        vm.sum_cart_total=sum;
        //calculate total  product  amount
        for (var i = 0, totalSum = 0; i < vm.carts.length; totalSum += vm.carts[i++].cart_quantity);
        vm.cartsCountProduct=totalSum;
        localStorage.setItem("cartsCountProduct", totalSum);
        $(".carts .badge").text(vm.carts.length);
      },
      increment() {
        this.quantity++;
      },
      decrement() {
        if (this.quantity === 1) {
        } else {
          this.quantity--;
        }
      },
      cartIncrement(product_id) {
        //alert(product_id);
        let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
        let oldQuantity = this.carts[objIndex].cart_quantity;
        let stock_quantity = this.carts[objIndex].stock_quantity;
        if(oldQuantity<stock_quantity){
          let newQuantity = oldQuantity + 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
          $('#'+product_id+ " .amountQuantity").text(newQuantity);
          this.calculateCartTotal();
          $("#"+product_id).addClass("animated");
          setTimeout(function(){
            $("#"+product_id).removeClass("animated");
          }, 500);
        }
      },
      cartDecrement(product_id) {
        let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
        let oldQuantity = this.carts[objIndex].cart_quantity;
        if (oldQuantity > 1) {
          let newQuantity = oldQuantity - 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          this.calculateCartTotal();
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
        } else {
        }
      },
      removeCartItem: function (product_id) {
        //alert(product_id);
        this.carts = this.carts.filter((e) => e.product_id !== product_id);
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.calculateCartTotal();
      },
      createCarts: function (index) {
        let vm = this;
        //check  array  index  product  info
        //console.log(this.products[index]);
        var result = JSON.parse(localStorage.getItem("carts"));
        if (result == null)
          result = [];
        result.push({
          'product_id': this.products[index].id,
          'product_name': this.products[index].name,
          'product_image': this.products[index].featured_image,
          'price': this.products[index].total_price,
          'image': this.products[index].featured_image,
          'cart_quantity': 1,
          'subtotal': this.products[index].total_price * 1
        });
        this.calculateCartTotal();
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));

        //retrive data and convert into an array
        //match  array and  update array  object  value
        // result.findIndex(project => project.value==='pentaxyl-294');
        // result[index].slug = "updated desc";
        // console.log(result);

      },
      checkout: function () {
        // console.log(this.globalUrl+'cart');
        // this.carts.push('test' , 12);
        axios.post(this.globalUrl + 'orders',
          {
            customer_id: JSON.parse(localStorage.getItem("logged_in_user_id")),
            order_total: this.sum_cart_total + this.delivery_charge,
            phone: this.phone,
            name: this.fullname,
            deliveryAddress: this.deliveryAddress,
            data: this.carts
          }, {crossdomain: true})
          //{ crossdomain: true },{headers: {"content-type" : 'application/json' }
          .then((response) => {
            localStorage.removeItem("carts");
            this.carts = [];
            //console.log(response);
            this.$toasted.show(' Successful', {
              type: 'success',
              icon: 'fa-exclamation-triangle'
            });
          })
          .catch((response) => {
            //console.log(response);
            //vm.$parent.endLoading();
            this.$toasted.show('Something wrong Please Try  again', {
              type: 'error',
              icon: 'fa-exclamation-triangle'
            });
          });
      }
    }
  };
</script>
